import React from 'react';

interface DemoHighlightBadgeProps {
  text: string;
}

const DemoHighlightBadge: React.FC<DemoHighlightBadgeProps> = ({ text }) => (
  <div className="absolute top-3 right-3 z-40 animate-pulse">
    <div className="bg-blue-600/90 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full shadow-lg border border-blue-400/30 max-w-xs">
      <span className="mr-1">&#10024;</span>
      {text}
    </div>
  </div>
);

export default DemoHighlightBadge;
